import { Injectable } from "@angular/core";
import { environment } from "./../../environments/environment";
import { HttpClient } from "@angular/common/http";
@Injectable({
	providedIn: "root",
})
export class CommonService {
	constructor(private http: HttpClient) {}
	getSurvey(flag) {
		console.log(flag);

		return new Promise((resolve, reject) => {
			const url = environment.npsGogitUrl + "/surveys/start-survey/" + flag;
			console.log(url);

			this.http
				.get(url)
				.toPromise()
				.then((res: any) => {
					console.log(res);
					resolve(res);
				})
				.catch((err) => {
					console.log(err);
				});
		});
	}
	finishSurvey(data) {
		return new Promise((resolve, reject) => {
			console.log(data);

			const url = environment.npsGogitUrl + "/surveys/finished";
			console.log(url);

			this.http
				.post(url, data)
				.toPromise()
				.then((response) => {
					console.log(response);
					resolve(response);
				});
		});
	}

	noFinishSurvey(data) {
		return new Promise((resolve, reject) => {
			console.log(data);

			const url = environment.npsGogitUrl + "/surveys/no-finished";
			console.log(url);

			this.http
				.post(url, data)
				.toPromise()
				.then((response) => {
					console.log(response);
					resolve(response);
				});
		});
	}

	getLocation(ofi) {
		return new Promise((resolve, reject) => {
			const url = environment.npsGogitUrl + "/location-office/" + ofi;
			this.http
				.get(url)
				.toPromise()
				.then((res: any) => {
					console.log(res);
					resolve(res);
				})
				.catch((err) => {
					console.log(err);
				});
		});
	}
	getCitys(codigo) {
		return new Promise((resolve, reject) => {
			const url = environment.npsGogitUrl + "/citys/" + codigo;
			this.http
				.get(url)
				.toPromise()
				.then((res: any) => {
					console.log(res);
					resolve(res);
				})
				.catch((err) => {
					console.log(err);
				});
		});
	}
	getCountryByRegion(codigo) {
		return new Promise((resolve, reject) => {
			const url = environment.npsGogitUrl + "/country-for-region/" + codigo;
			this.http
				.get(url)
				.toPromise()
				.then((res: any) => {
					console.log(res);
					resolve(res);
				})
				.catch((err) => {
					console.log(err);
				});
		});
	}
	setClick() {
		return new Promise((resolve, reject) => {
			const url = environment.npsGogitUrl + "/surveys/click-action";
			console.log(url);

			this.http
				.get(url)
				.toPromise()
				.then((response) => {
					console.log(response);
					resolve(response);
				});
		});
	}
	setClickTest() {
		return new Promise((resolve, reject) => {
			const url = environment.npsGogitUrl + "/surveys/click-action-test";
			console.log(url);

			this.http
				.get(url)
				.toPromise()
				.then((response) => {
					console.log(response);
					resolve(response);
				});
		});
	}
	getSurveyFirst() {

		return new Promise((resolve, reject) => {
			const url = environment.npsGogitUrl + "/surveys/start-survey-first";
			console.log(url);

			this.http
				.get(url)
				.toPromise()
				.then((res: any) => {
					console.log(res);
					resolve(res);
				})
				.catch((err) => {
					console.log(err);
				});
		});
	}
}
